module.exports = __webpack_public_path__ + "img/button_next.1e2dbdfb.png";